import { Component, ViewEncapsulation } from '@angular/core';
import { fuseAnimations } from '../../animations';
import { MatSnackBar } from '@angular/material';


@Component({
    selector: 'toast',
    template: '',
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations
})
export class ToastComponent {
    constructor(
        private snackBar: MatSnackBar,
    ) {
    }
    //Toast message 
    showToast(message: string) {
        this.snackBar.open(message, 'Ok', {
            verticalPosition: 'top',
            duration: 2000
        });
    }
}


// WEBPACK FOOTER //
// E:/NeoSME/1.Full Project Spekwo/pro/prodash/src/app/core/components/toast/toast.component.ts